import thdCustomer from '@thd-olt-global/thd-customer';
import { isMobile } from 'react-device-detect';
import { api } from './base';
import { getTMXSessionID } from '../utils';

export function reportActivityApi(eventId, eventTs) {
  const namespaces = 'identity,security';
  const activityRequest = {
    method: 'post',
    url: `/customer/account/v1/activity/report?namespaces=${namespaces}`,
    headers: {
      Accept: 'application/json',
      Channelid: isMobile ? '2' : '1',
      Authorization: thdCustomer.jwt,
      TMXProfileID: getTMXSessionID(),
      ClientOrigin: window.location.origin
    },
    data: { eventId, eventTs }
  };

  return api(activityRequest)
    .then((res) => {
      return res?.data?.events;
    });
}
